import React, { useEffect, useState } from "react"
import axios from "axios"

import { getStorage, ref, getDownloadURL } from "firebase/storage"
import { auth } from "../../../firebase"

import ProductImage from "../../../assets/productos/product.png"

import PointItem from "./pointItem"

import { ProgressSpinner } from "primereact/progressspinner"
import { useUserContext } from "../../../context/usercontext"

import GLOBAL from "../../../config/variable"

function PointsList() {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState(null)
  const { user, userData } = useUserContext()

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setIsLoading(true)
        const response = await axios.get(`${GLOBAL.SERVER_URL}/rewards/`, {
          headers: {
            Authorization: `Bearer ${user.accessToken}`,
          },
        })
        if (response.data.success) {
          // Obtener las URLs de las imágenes para cada item
          const itemsWithImages = await Promise.all(
            response.data.data.map(async (item) => {
              if (item.image_src) {
                try {
                  const storage = getStorage()
                  const imageRef = ref(storage, item.image_src)
                  const url = await getDownloadURL(imageRef)
                  return { ...item, image_url: url }
                } catch (error) {
                  console.error("Error al obtener la URL de la imagen:", error)
                  return { ...item, image_url: ProductImage }
                }
              }
              return { ...item, image_url: ProductImage }
            })
          )
          setData(itemsWithImages)
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Redirigir al login si la respuesta es 401
          auth.signOut()
        }
        console.error("Error al obtener los productos:", error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchProduct()
  }, [user.accessToken])

  if (isLoading) {
    return (
      <div
        className="flex justify-content-center align-items-center"
        style={{ height: "200px" }}
      >
        <ProgressSpinner />
      </div>
    )
  }

  if (!data) {
    return (
      <div
        className="flex justify-content-center align-items-center"
        style={{ height: "200px" }}
      >
        <p className="text-white">No hay productos disponibles</p>
      </div>
    )
  }

  const handleData = () => {
    return data
      .filter((item) => !item.disabled)
      .filter((item) => item.stock !== 0)
      .map((item) => (
        <PointItem
          key={item.id}
          productImage={item.image_url}
          productName={item.title}
          productPoints={item.points}
          description={item.description}
          id={item.id}
          userPoints={userData?.points || 0}
          redeemable={item.redeemable}
        />
      ))
  }

  return (
    <div className="bg-white border-round p-5">
      <h2 className="mt-0">Recompensas</h2>
      <div className="grid">{handleData()}</div>
    </div>
  )
}

export default PointsList
